import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CombinedState } from 'reducers';
import { activateObject } from 'actions/annotation-actions';
import { getCore } from 'cvat-core-wrapper';
import { keyOf } from './model-card';
import { usePreviewMode } from './preview-mode';
import PreviewPanel from './preview-panel';

export default function PreviewPanelContainer(): JSX.Element | null {
    const dispatch = useDispatch();
    const states = useSelector((state: CombinedState) => state.annotation.annotations.states);
    const canvas = useSelector((state: CombinedState) => state.annotation.canvas.instance);
    const margin = useSelector((state: CombinedState) => state.settings.workspace.aamZoomMargin);
    const preview = usePreviewMode();
    if (!preview) return null;
    const activate = (clientID: number): void => { dispatch(activateObject(clientID, null, null)); };
    return (
        <PreviewPanel
            states={states}
            backendAPI={getCore().config.backendAPI}
            pinned={preview.pinned}
            onHover={(state) => activate(state.clientID)}
            onPin={(state) => {
                preview.pin(keyOf(state));
                activate(state.clientID);
                // zoomed in on a click only: a hover moving the drawing would follow every mouse move;
                // the 3D canvas has no focus, and the cvat-canvas import would load svg.js into the sidebar tests
                if (canvas && 'focus' in canvas) canvas.focus(state.clientID, margin);
            }}
            onChange={(state, all) => {
                preview.pin(keyOf(state));
                preview.setPicking(true, all);
            }}
        />
    );
}
